import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './AlertBox.scss';

import InfoIcon from '../../assets/info-icon.svg';
import DangerIcon from '../../assets/danger-icon.svg';

const AlertBox = (props) => {
  const { message, variant } = props;
  return (
    <div className={classnames('alert-box', { [`${variant}`]: !!variant })}>
      {variant === 'warning' ? <img src={InfoIcon} alt="info icon" /> : <img src={DangerIcon} alt="danger icon" />}

      <span>{message}</span>
    </div>
  );
};

AlertBox.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  variant: PropTypes.string,
};

export default AlertBox;
